<template>
  <div class="discount">
    <div class="discount__wrapper">
      <div class="discount__wrapper__header">
        <div class="discount__wrapper__header__top">
          <router-link :to="{ name: 'sharing' }">
          <img src="/img/icons/ic-arrow-left.svg" alt="">
          Sharing
          </router-link>
        </div>
        <div class="discount__wrapper__header__bottom">
          <div class="discount__wrapper__header__bottom__left">
            <h1 class="medium-title">Discount Sharing</h1>
            <p>{{ campaignName }}</p>
          </div>
          <div class="discount__wrapper__header__bottom__right">
            <div class="discount__wrapper__header__bottom__right__gross">
              <h1 class="regular-font">{{ gross | formatMoney }}</h1>
              <h1 class="micro-font">Total Price (Gross)</h1>
            </div>
          </div>
        </div>
        <div class="discount__wrapper__header__functionality">
          <div class="discount__wrapper__header__functionality__left">
            <div class="discount__wrapper__header__functionality__left__search">
              <i class="adx-ic_search"></i>
              <input type="text" placeholder="Search Listing" v-model="searchBoxValue">
            </div>
            <div class="discount__wrapper__header__functionality__left__status">
              <adx-list-dropdown :list="categoriesDropdown" :labelButton="`All Categories`" @selected="selectCategory"/>
            </div>
          </div>
        </div>
      </div>
      <div class="discount__wrapper__list">
        <table>
          <thead>
            <tr>
              <td class="header">Location</td>
              <td class="header">Shares</td>
              <td class="header">Alt. Disc / Device</td>
              <td class="header"></td>
            </tr>
          </thead>
          <tbody v-if="!isLoading && !isEmpty">
            <tr v-for="(list, index) in processedLists" :key="index">
              <td class="body">{{ list.device.name }}</td>
              <td class="body">
                  <tr class="dynamic">
                    <td>Adx</td>
                    <td>{{ Math.round(list.adxShare * 100 * 100)/100 }} %</td>
                  </tr>
                  <tr v-for="(role, index) in list.roles" :key="index" class="dynamic">
                    <td v-if="role.role == 1">Host</td>
                    <td v-else-if="role.role == 2">Investor</td>
                    <td v-else>Consultant</td>
                    <td>{{ Math.round(role.share * 100 * 100)/100 }} %</td>
                  </tr>
              </td>
              <td class="body">{{ list.device.allocation | formatMoney}}</td>
              <td class="body"><button class="btn-small secondary" @click="openModal(list)">Edit</button></td>
            </tr>
          </tbody>
        </table>
        <adx-loading v-if="isLoading" slot="loading" class="loading"/>
        <div v-if="!isLoading && isEmpty">
          <div class="empty">
            <img src="/img/notfound/img-empty-draft@2x.png" alt="">
            <span class="text">Your data is empty.</span>
          </div>
        </div>
      </div>
      <div v-if="!isLoading && !isEmpty" class="discount__wrapper__buttons">
        <button class="btn-regular secondary" @click="cancel">Cancel</button>
        <button class="btn-regular primary" @click="save">Save</button>
      </div>
      <modal v-if="isShowModal" @modal-close="closeModal" title="Discount Sharing Scheme">
        <div slot="content" class="discount__wrapper__modal">
          <div class="row">
            <adx-input label="Discount Value (Rp)" class="field2" :value.sync="newDiscount" type="number"/>
          </div>
          <div class="row">
            <span>Adx</span>
            <div>
              <adx-input :label="`Percentage`" class="field" v-model="adxShare" :disabled="true"/>
            </div>
          </div>
          <div v-for="(role, index) in model.roles" :key="index" class="row">
            <span v-if="role.role == 1">Host</span>
            <span v-else-if="role.role == 2">Investor</span>
            <span v-else>Consultant</span>
            <div>
              <adx-input :label="`Percentage`" class="field" :value.sync="role.share" :button="`Delete`" @buttonClicked="deleteRole(index)" type="number"/>
            </div>
          </div>
          <div v-if="!isShareValid" class="row">
            <span class="error">Total percentage can't be higher than 100%</span>
          </div>
          <div v-if="!isDiscountValid" class="row">
            <span class="error">Custom discount can't be higher than default discount</span>
          </div>
          <div class="buttons2">
            <div class="left"><button @click="addDiscountRole">Add more roles</button></div>
            <div class="right">
              <button class="btn-regular secondary" @click="closeModal">Cancel</button>
              <button class="btn-regular primary" @click="applyRoles" :disabled="!isShareValid || !isDiscountValid">Ok</button>
            </div>
          </div>
        </div>
      </modal>
      <modal v-if="isShowDiscountRoleModal" @modal-close="closeDiscountRoleModal" title="Add User Role">
        <div slot="content" class="discount__wrapper__modal">
          <div>
            <adx-select-dropdown :label="`User`" :options="userOptions" class="dropdown" :value.sync="newUser"/>
            <adx-select-dropdown :label="`Role`" :options="roleOptions" class="dropdown" :value.sync="newRole"/>
          </div>
          <div class="buttons1">
            <button class="btn-regular secondary" @click="closeDiscountRoleModal">Cancel</button>
            <button class="btn-regular primary" @click="saveNewRole">Save</button>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import Modal from '@/components/Modal'
import Input from '@/components/Form/Input'
import Checkbox from '@/components/Form/Checkbox'
import SelectDropdown from '@/components/Form/SelectDropdown'
import Loading from '@/components/Loading/Primary'
import EmptySelection from '@/components/NotFound/Selection'
import DropdownList from '@/components/Dropdown/ListDropdown'
import * as validationLib from '@/lib/validation/'
const {
  helpers,
  validate
} = validationLib

import api from '@/api'
import { apiV2 } from '@/api/urls'
import { formatShortDate } from '@/lib/util'

export default {
  name: 'adx-sharing-discount',
  components: {
    'adx-input': Input,
    'adx-checkbox': Checkbox,
    'adx-select-dropdown': SelectDropdown,
    'adx-loading': Loading,
    'adx-empty-selection': EmptySelection,
    'adx-list-dropdown': DropdownList,
    Modal,
  },
  props: {

  },
  data() {
    return {
      selectedCategory: '',
      defaultDiscount: 0,
      allowedDiscount: 0,
      gross: 0,
      campaignName: null,
      isShareValid: null,
      isDiscountValid: null,
      isShowDiscountRoleModal: false,
      newUser: null,
      newRole: null,
      newDiscount: null,
      searchBoxValue: '',
      isShowModal: false,
      isLoading: false,
      isEmpty: false,
      model: {
        id: null,
        adxShare: null,
        roles: []
      },
      checkbox: '',
      lists: [],
      processedLists: [],
      userOptions: [],
      roleOptions: [
        {
          value: 1,
          label: 'Host'
        },
        {
          value: 2,
          label: 'TV Investor'
        },
        {
          value: 3,
          label: 'Consultant'
        },
      ],
      categoriesDropdown: [
        {
          id: 0,
          value: '',
          label: 'All Categories'
        },
        {
          id: 1,
          value: 'LS',
          label: 'Lifestyle'
        },
        {
          id: 2,
          value: 'BU',
          label: 'SPBU'
        },
        {
          id: 3,
          value: 'AR',
          label: 'Airport'
        },
        {
          id: 4,
          value: 'ML',
          label: 'Malls'
        },
      ]
    }
  },
  computed: {
    adxShare: function () {
      let totalShare = 0
      this.model.roles.map(role => {
        totalShare += parseInt(role.share)
      })

      let adxShare = 100 - totalShare

      adxShare < 0 ? this.isShareValid = false : this.isShareValid = true

      return adxShare
    }
  },
  watch: {
    searchBoxValue: helpers.debounce(function() {
      this.$nextTick(() => {
        this.filterData()
      })
    }, 500),
    selectedCategory: function() {
      this.$nextTick(() => {
        this.filterData()
      })
    },
    newDiscount: function() {
      this.newDiscount > this.allowedDiscount ? this.isDiscountValid = false : this.isDiscountValid = true
    }
  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    this.initialLoad()
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    initialLoad() {
      (async () => {
        this.userOptions= []
        this.isLoading = true

        const userData = await api.get(apiV2.users, { needToken: true })
        userData.data.map(user => {
          this.userOptions.push(
            {
              value: user.id,
              label: user.email
            }
          )
        })

        const { data } = await api.get(apiV2.sharingDiscount(this.$route.params.id), { needToken: true })
        let rawData = data.data

        this.gross = data.campaign.price
        this.campaignName = data.campaign.name

        this.lists = data.data
        this.lists.map(list => {
          let totalShare = 0
          list.roles.map(role => {
            totalShare += role.share
          })
          list.adxShare = 1 - totalShare
        })
        this.processedLists = this.lists

        this.getDiscount()

        this.isLoading = false
      })();
    },
    addDiscountRole() {
      this.isShowDiscountRoleModal = true
    },
    closeDiscountRoleModal() {
      this.isShowDiscountRoleModal = false
    },
    saveNewRole() {
      this.model.roles.push({
        role: this.newRole,
        user: this.newUser,
        share: 0,
      })
      
      this.newRole = null
      this.newUser = null
      this.isShowDiscountRoleModal = false
    },
    openModal(list) {
      this.isShowModal = !this.isShowModal

      this.allowedDiscount = 0
      let total = 0
      this.processedLists.map(obj => {
        if (obj.device.id != list.device.id) {
          total += obj.device.allocation
        }
      })
      this.allowedDiscount = this.defaultDiscount - parseInt(total)
      
      this.model.id = list.device.id
      this.newDiscount = Math.round(list.device.allocation)
      list.roles.map(role => {
        this.model.roles.push({
          user: role.user,
          share: Math.round(role.share * 100 * 100)/100,
          role: role.role
        })  
      })
      this.model.adxShare = this.adxShare
    },
    closeModal() {
      this.model.roles = []
      this.isShowModal = false
    },
    applyRoles() {
      this.processedLists.map(list => {
        if (list.device.id == this.model.id) {
          list.adxShare = this.adxShare / 100
          list.device.allocation = parseInt(this.newDiscount)
          list.roles = []
          this.model.roles.map(role => {
            list.roles.push({
              user: role.user,
              role: role.role,
              share: role.share/100
            })
          })
        }
      })
      
      this.model.roles = []
      this.isShowModal = false
    },
    save() {
      let total = 0
      this.processedLists.map(list => {
        total += list.device.allocation
      })
      if (total != this.defaultDiscount) {
        this.$notify({
          group: 'saved',
          title: 'Error',
          text: 'Total discount must be equal with default discount!',
          type: 'danger'
        })
      } else {
        (async () => {
          let data = []
          this.processedLists.map(list => {
            data.push({
              device: {
                id: list.device.id,
                allocation: list.device.allocation,
              },
              roles: list.roles
            })
          })
          
          const response = await api.put(apiV2.sharingDiscount(this.$route.params.id), data, { needToken: true })
          if (response.status == 200) {
            this.$notify({
              group: 'saved',
              title: 'Discount sharing scheme',
              text: 'Data successfully saved.',
              type: 'success'
            })
            this.initialLoad()
          } else {
            this.$notify({
              group: 'saved',
              title: 'Error',
              text: 'Sorry something went wrong!',
              type: 'danger'
            })
          }
        })()
      }

    },
    cancel() {
      this.$router.push({ name: 'sharing' })
    },
    selectCategory(item){
      this.selectedCategory = item.value
    },
    filterData() {
      this.isEmpty = false
      let array = this.lists

      if (this.searchBoxValue) {
        array = array.filter(list => {
          let listLocation = list.device.name.toLowerCase()
          let searchValue = this.searchBoxValue.toLowerCase()
          return listLocation.includes(searchValue)
        })
      }

      if (this.selectedCategory) {
        array = array.filter(list => {
          return list.device.category.includes(this.selectedCategory)
        })
      }

      this.processedLists = array
      if (!this.processedLists.length) this.isEmpty = true
    },
    deleteRole(index) {
      this.model.roles.splice(index, 1)
    },
    getDiscount: function() {
      this.processedLists.map(list => {
        this.defaultDiscount += list.device.allocation
      })
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>

<style lang='scss'>
@import '~@/styles/variables';
@import '~@/styles/mixins';

.discount {
  .modal {

    &__content {
      width: 480px !important;
    }
  }

  .selectDropdown {
    .popup {
      max-height: 150px;
      overflow-y: auto !important;
    }
  }
}
</style>